<template>
  <BootstrapModal :show="showModal" :trigger-class=triggerClass :trigger-icon=triggerIcon
                  :trigger-text=triggerText submit-btn="Anlegen" title="Mehrere Messen anlegen" @close="handleClose"
                  @open="handleOpen" @save="bulkAdd">
    <template v-slot:body>
      <form class="row row-cols-3 g-3">
        <div class="col">
          <label class="form-label" for="startDate">Start-Datum</label>
          <input id="startDate" v-model="massBulkData.startDate" class="form-control" required type="date">
        </div>
        <div class="col">
          <label class="form-label" for="endDate">End-Datum</label>
          <input id="endDate" v-model="massBulkData.endDate" class="form-control" required type="date">
        </div>
        <div class="col">
          <label class="form-label" for="dayOfWeek">Wochentag</label>
          <select id="dayOfWeek" v-model="massBulkData.dayOfWeek" class="form-select" required>
            <option value="MO">Montag</option>
            <option value="DI">Dienstag</option>
            <option value="MI">Mittwoch</option>
            <option value="DO">Donnerstag</option>
            <option value="FR">Freitag</option>
            <option value="SA">Samstag</option>
            <option value="SO">Sonntag</option>
          </select>
        </div>
        <div class="col">
          <label class="form-label" for="time">Uhrzeit</label>
          <input id="time" v-model="massBulkData.time" class="form-control" required type="time">
        </div>
        <div class="col">
          <div class="form-check">
            <label class="form-label" for="incense">Weihrauch?</label>
            <input id="incense" v-model="massBulkData.incense" class="form-check-input" required type="checkbox">
          </div>
        </div>
        <div class="col">
          <div class="form-check">
            <label class="form-check-label" for="boldTime">Uhrzeit dick?</label>
            <input id="boldTime" v-model="massBulkData.boldTime" class="form-check-input" type="checkbox">
          </div>
        </div>
        <div class="col">
          <label class="form-label" for="requiredAltarServers">Anz. Messdiener</label>
          <input id="requiredAltarServers" v-model="massBulkData.requiredAltarServers" class="form-control"
                 required type="number">
        </div>
        <div class="col">
          <label class="form-label" for="requiredLeaders">Anz. Leiter</label>
          <input id="requiredLeaders" v-model="massBulkData.requiredLeaders" class="form-control" required
                 type="number">
        </div>
        <div class="col">
          <label class="form-label" for="annotation">Anmerkung</label>
          <input id="annotation" v-model="massBulkData.annotation" class="form-control" type="text">
        </div>
      </form>
    </template>
  </BootstrapModal>
</template>

<script>
import BootstrapModal from "@/components/BootstrapModal";
import {useMassStore} from "@/stores/mass";

export default {
  name: "MassBulkCreateModal",
  components: {BootstrapModal},
  props: ['triggerIcon', 'triggerText', 'triggerClass'],
  data: function () {
    return {
      massBulkData: {},
      showModal: false
    }
  },
  methods: {
    handleOpen() {
      this.showModal = true;
      this.massBulkData = {};
    },
    handleClose() {
      this.showModal = false;
      this.massBulkData = {};
    },
    bulkAdd() {
      this.massStore.bulkCreateMasses(this.massBulkData);
      this.handleClose();
    }
  },
  created() {
    if (!this.massStore.loadedData)
      this.massStore.getData();
  },
  setup() {
    const massStore = useMassStore();
    return {massStore};
  }
}
</script>
